import React, { useImperativeHandle, useState, forwardRef, useRef } from "react";

import ToastContainer from 'react-bootstrap/ToastContainer';
import ToastNotif from "@app/components/1_elements/ToastNotif";

/**
 * Manager Toast notification
 * To display a new toast - use the addToast function with title, description and time parameters
 * 
 * @returns 
 */
const ToastContNotif = forwardRef(function ToastContNotif({}, ref) {
    const [toasts, setToasts] = useState([]);

    const toastContainerRef = useRef(null);

    useImperativeHandle(ref, ()=>({
        addToast(title, description, time, icon) {
            setToasts([...toasts, {title: title, description: description, time: time, icon: icon}])
        }
    }));

    function displayToast(toast, index) {
        return (
            <ToastNotif key={index} toast={toast} />                    
        )
    }

    return (            
        <ToastContainer ref={toastContainerRef} className="p-3 position-fixed" position="bottom-end" style={{ zIndex: 2000 }}>
            {toasts.map(displayToast)}
        </ToastContainer>  
    )
})

export default ToastContNotif;